var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromoRandom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ix:random-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.532 4.22875L11.7713 14.532L1.46803 11.7713L4.22875 1.46803L14.532 4.22875ZM9.90875 9.89181C9.37528 9.74888 8.82694 10.0655 8.684 10.5989C8.54106 11.1324 8.85763 11.6807 9.39109 11.8237C9.92456 11.9666 10.4729 11.65 10.6158 11.1166C10.7588 10.5831 10.4422 10.0348 9.90875 9.89181ZM8.25881 7.03406C7.72538 6.89112 7.17703 7.20772 7.03406 7.74119C6.89112 8.27462 7.20772 8.823 7.74119 8.96594C8.27466 9.10887 8.82297 8.79228 8.96594 8.25881C9.10887 7.72538 8.79228 7.17703 8.25881 7.03406ZM6.60891 4.17634C6.07544 4.03341 5.52709 4.34997 5.38416 4.88344C5.24122 5.41691 5.55781 5.96525 6.09125 6.10819C6.62472 6.25113 7.17306 5.93456 7.316 5.40109C7.45894 4.86763 7.14237 4.31928 6.60891 4.17634Z",
    fill: "#5B4E4C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoRandom);
export default __webpack_public_path__ + "static/media/promoRandom.6bc2d52f733b571052d62df9b5a90511.svg";
export { ForwardRef as ReactComponent };